import React from 'react';
import Navbar from '../components/Navbar';
import FranchiseHero from '../components/franchise/FranchiseHero';
import FranchiseProblem from '../components/franchise/FranchiseProblem';
import WhyTraainFranchise from '../components/franchise/WhyTraainFranchise';
import TrainingIntelligenceFranchise from '../components/franchise/TrainingIntelligenceFranchise';
import RolePlayIntelligenceFranchise from '../components/franchise/RolePlayIntelligenceFranchise';
import FranchiseKPIs from '../components/franchise/FranchiseKPIs';
import FranchiseCTA from '../components/franchise/FranchiseCTA';
import Footer from '../components/Footer';

const FranchisePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <FranchiseHero />
        <FranchiseProblem />
        <WhyTraainFranchise />
        <TrainingIntelligenceFranchise />
        <RolePlayIntelligenceFranchise />
        <FranchiseKPIs />
        <FranchiseCTA />
        <Footer />
      </div>
    </div>
  );
};

export default FranchisePage;
